<template>
  <div>
    <el-dialog :visible.sync="showDialog"
               :close-on-press-escape="false"
               :close-on-click-modal="false"
               width="40%"
               top="5vh"
               :show-close="false"
               :title="title">
      <template data-id="room-list"
                v-if="step===1">
        <div class="room-box">
          <myScroll style="width:100%;height:100%">
            <el-table :data="roomList"
                      ref="tableLayer"
                      @row-click="handleRowClick"
                      @selection-change="handleSelectionChange"
                      size="mini">
              <el-table-column :label="$t('model.RoomName')"
                               property="name"></el-table-column>
              <el-table-column type="selection"
                               width="45">
              </el-table-column>
            </el-table>
          </myScroll>
        </div>
      </template>
      <template data-id="form"
                v-if="step===2">
        <div class="form-box">
          <el-form label-position="left"
                   label-width="50%"
                   size="medium">
            <myScroll style="width:100%;height:100%">
              <div style="margin:0 auto;width:95%">
                <template class="single-task"
                          v-if="listForSave.length<=1 ">
                  <!-- <el-form-item :label="$t('model.Name')">
                    <el-input size="mini"
                              v-model="Name"></el-input>
                  </el-form-item> -->
                  <el-form-item :label="$t('model.Status')">
                    <el-select size="small"
                               v-model="form.Status">
                      <el-option v-for=" i of taskStatus"
                                 :key="i.Value"
                                 :label="$t('api.'+i.Key)"
                                 :value="i.Value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.TaskGroup')">
                    <el-select size="small"
                               style="width:85%"
                               clearable
                               v-model="form.TaskPhaseId">
                      <el-option v-for="i of taskGroup"
                                 :key="i.PhaseId"
                                 :label="i.Name"
                                 :value="i.PhaseId"></el-option>
                    </el-select>
                    <el-button circle
                               type="primary"
                               size="small"
                               v-has="'Create Task Group'"
                               :title="$t('groupDialog.AddTaskGroup')"
                               style="position: absolute;top:50%;transform: translateY(-50%);right:0"
                               @click="openGroupDialog"><i class="el-icon-plus"></i></el-button>
                  </el-form-item>
                  <el-form-item :label="$t('model.StartDate')">
                    <el-date-picker v-model="form.StartDate"
                                    size="small"
                                    :placeholder="$t('model.Select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('model.DueDate')">
                    <el-date-picker v-model="form.EndDate"
                                    size="small"
                                    :placeholder="$t('model.Select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('model.Assignee')">
                    <el-select @change="changeAssign"
                               size="small"
                               clearable
                               v-model="assign"
                               :placeholder="$t('model.SelectAssignee')">
                      <el-option v-for="item in projectUser"
                                 :key="item.UserId"
                                 :label="item.FullName"
                                 :value="item.UserId">
                        <div class="user-logo">
                          <img :src="item.AvatarUrl"
                               alt="">
                        </div>
                        <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.Watching')">
                    <el-select v-model="form.WatchingUserIds"
                               clearable
                               size="small"
                               multiple
                               :placeholder="$t('model.SelectWatching')">
                      <el-option v-for="item in projectUser"
                                 :key="item.UserId"
                                 :label="item.FullName"
                                 :value="item.UserId">
                        <div class="user-logo">
                          <img :src="item.AvatarUrl"
                               alt="">
                        </div>
                        <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.Location')">
                    <el-tag v-for="i in roomCheck"
                            :key="i.id">{{i.name}}</el-tag>
                  </el-form-item>
                  <div style="display:none">
                    <el-row>
                      <el-col :span="24">
                        <el-form-item label-width="0">
                          <el-upload ref="upload"
                                     action=""
                                     :multiple="true"
                                     :accept="picAccept"
                                     :auto-upload="false"
                                     style="width:100%"
                                     :show-file-list="false"
                                     :file-list="allFileList"
                                     :on-change="handlePicChange"
                                     :on-success="handlePicSuccess"
                                     :on-exceed="masterFileMax"
                                     :http-request="postUpPic">
                            <el-button slot="trigger"
                                       style="width:100%"
                                       size="small"
                                       type="primary">{{$t('taskDialog.AddPhoto')}}</el-button>
                          </el-upload>
                          <div class="pic-box"
                               :style="{height:picList.length>=4? height +'px':height}"
                               v-if="picList.length>0">
                            <myScroll style="width:94%;height:100%;margin:0 auto">
                              <el-table :data="picList"
                                        :show-header="false">
                                <el-table-column width="55">
                                  <i class="el-icon-document"></i>
                                </el-table-column>
                                <el-table-column>
                                  <template slot-scope="scope">
                                    {{scope.row.name}}
                                  </template>
                                </el-table-column>
                                <el-table-column width="55">
                                  <template slot-scope="scope">
                                    <el-button size="mini"
                                               circle
                                               @click="removePic(scope.$index)"
                                               type="danger">
                                      <i class="el-icon-delete"></i>
                                    </el-button>
                                  </template>
                                </el-table-column>
                              </el-table>
                            </myScroll>
                          </div>
                        </el-form-item>
                      </el-col>
                    </el-row>
                    <el-form-item :label="$t('model.Description')"
                                  label-width="20%">
                      <el-input size="small"
                                v-model="form.Description"
                                type="textarea"
                                :placeholder="$t('model.DescribeTheTask')"></el-input>
                    </el-form-item>
                  </div>
                  <el-form-item :label="$t('model.CreateTaskForEveryRoom')">
                    <el-switch v-model="forAll">
                    </el-switch>
                    <span v-if="!forAll"> {{computedListForSave.length}} {{$t('model.tasks are going to be created')}}</span>
                    <span v-if="forAll"> {{roomCheck.length}} {{$t('model.tasks are going to be created')}}</span>
                  </el-form-item>
                </template>

                <template class="batch-task"
                          v-if="listForSave.length>1">
                  <el-form-item :label="$t('model.Status')">
                    <el-select size="small"
                               v-model="form.Status">
                      <el-option v-for=" i of taskStatus"
                                 :key="i.Value"
                                 :label="$t('api.'+i.Key)"
                                 :value="i.Value"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.TaskGroup')">
                    <el-select size="small"
                               clearable
                               style="width:85%"
                               v-model="form.TaskPhaseId">
                      <el-option v-for="i of taskGroup"
                                 :key="i.PhaseId"
                                 :label="i.Name"
                                 :value="i.PhaseId"></el-option>
                    </el-select>
                    <el-button circle
                               type="primary"
                               size="small"
                               v-has="'Create Task Group'"
                               :title="$t('groupDialog.AddTaskGroup')"
                               style="position: absolute;top:50%;transform: translateY(-50%);right:0"
                               @click="openGroupDialog"><i class="el-icon-plus"></i></el-button>
                  </el-form-item>
                  <el-form-item :label="$t('model.StartDate')">
                    <el-date-picker v-model="form.StartDate"
                                    size="small"
                                    :placeholder="$t('model.Select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('model.DueDate')">
                    <el-date-picker v-model="form.EndDate"
                                    size="small"
                                    :placeholder="$t('model.Select')">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item :label="$t('model.Assignee')">
                    <el-select @change="changeAssign"
                               size="small"
                               clearable
                               v-model="assign"
                               :placeholder="$t('model.SelectAssignee')">
                      <el-option v-for="item in projectUser"
                                 :key="item.UserId"
                                 :label="item.FullName"
                                 :value="item.UserId">
                        <div class="user-logo">
                          <img :src="item.AvatarUrl"
                               alt="">
                        </div>
                        <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.Watching')">
                    <el-select v-model="form.WatchingUserIds"
                               clearable
                               size="small"
                               multiple
                               :placeholder="$t('model.SelectWatching')">
                      <el-option v-for="item in projectUser"
                                 :key="item.UserId"
                                 :label="item.FullName"
                                 :value="item.UserId">
                        <div class="user-logo">
                          <img :src="item.AvatarUrl"
                               alt="">
                        </div>
                        <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item :label="$t('model.CreateTaskForEveryRoom')">
                    <div style="margin-top:5px">
                      <el-switch v-model="forAll">
                      </el-switch>
                      <span v-if="!forAll"> {{computedListForSave.length}} {{$t('model.tasks are going to be created')}}</span>
                      <span v-if="forAll"> {{roomCheck.length}} {{$t('model.tasks are going to be created')}}</span>
                    </div>
                  </el-form-item>
                </template>
              </div>
            </myScroll>
          </el-form>
        </div>
      </template>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="small"
                   @click="close()">{{$t('model.Cancel')}}</el-button>
        <el-button type="primary"
                   v-if="step === 1"
                   size="small"
                   :disabled="roomList.length<1 || roomCheck.length<1"
                   @click="next">{{$t('model.Next')}}</el-button>
        <el-button type="primary"
                   v-if="step === 2"
                   size="small"
                   :loading="btnLoading"
                   @click="save">{{$t('model.Save')}}</el-button>
      </div>
    </el-dialog>
    <Group-Dialog :showDialog="groupDialog.showDialog"
                  :jobsiteId="form.JobsiteId"
                  @closeDialog="closeGroupDialog"></Group-Dialog>
  </div>
</template>

<script>
import { addTask } from '@/api/config'
import GroupDialog from '@components/group/groupDialog'
import { mapState } from 'vuex'
import { uuid } from 'vue-uuid'
import { Upload } from '@/api/request'

export default {
  props: {
    showDialog: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      btnLoading: false,
      title: '',
      roomList: [],
      roomCheck: [],
      step: 1,
      form: {
        TaskPhaseId: '',
        Status: 'Open',
        StartDate: new Date()
      },
      Name: '',
      groupDialog: {
        showDialog: false
      },
      assign: '',
      listForSave: [],
      allFileList: [],
      picList: [],
      picAccept: '.jpg,.jpeg,.png,.gif,.bmp',
      limit: 9,
      height: 0,
      forAll: true
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'taskStatus', 'taskType', 'taskWorkType', 'taskGroup', 'plan', 'projectUser']),
    addProductList () {
      return this.$store.state.diag.data.addProductList
    },
    productHandleList () {
      return this.$store.state.diag.data.productHandleList
    },
    roomCheckIds () {
      let ids = []
      for (const room of this.roomCheck) {
        ids.push(room.id)
      }
      return ids
    },
    computedListForSave () {
      var arr = []
      for (let ele of this.listForSave) {
        arr.push({
          room: this.roomCheck,
          product: ele.product.filter(a => this.roomCheckIds.indexOf(a.roomId) !== -1)
        })
      }
      return arr
    }
  },
  created () {
  },
  mounted () {
  },
  watch: {
    picList (to, from) {
      if (to.length > 5) {
        this.height = 200
      } else {
        this.height = 'auto'
      }
    },
    showDialog (to, from) {
      if (to) {
        this.picList = []
        this.form = {
          TaskPhaseId: '',
          Status: 'Open',
          StartDate: new Date()
        }
        this.init()
        this.forAll = true
        this.title = this.$t('model.SelectRoom')
      }
    },
    step (to, from) {
      if (to === 2) {
        let arr = []
        for (let i of this.productHandleList) {
          arr.push(i)
        }
        this.listForSave = arr
        this.Name = this.listForSave[0].product[0].prod.id + '-' + this.roomCheck[0].name
        this.title = this.$t('model.AddTask')
      }
    }
  },
  methods: {
    masterFileMax (files, fileList) {
      this.$message.warning(this.$t('upload.Pleaseuploadamaximumofphotos/videos', [this.limit]))
    },
    handlePicSuccess (file, fileList) {
      this.$refs.upload.clearFiles()
    },
    handlePicChange (file, fileList) {
      this.picList.push(file)
    },
    uploadingPic (file, taskId) {
      return new Promise((resolve, reject) => {
        let formData = new FormData()
        formData.append('file', file.raw)
        formData.append('taskId', taskId)
        let url = '/api/TaskPhotos'
        Upload(url, formData).then(result => {
          resolve(1)
        })
      })
    },
    async postUpPic (taskId) {
      return new Promise(async (resolve, reject) => {
        if (this.picList.length > 0) {
          let time = 0
          for (let i of this.picList) {
            time += await this.uploadingPic(i, taskId)
          }
          if (time === this.picList.length) {
            resolve()
          }
        } else {
          resolve()
        }
      })
    },
    removePic (index) {
      this.picList.splice(index, 1)
      this.allFileList = this.picList
    },
    handleRowClick (row, column, event) {
      this.$refs.tableLayer.toggleRowSelection(row)
    },
    handleSelectionChange (val) {
      this.roomCheck = val
      this.$store.commit('diag/setRoomCheck', val)
    },
    setRoomList () {
      return new Promise((resolve, reject) => {
        for (let i of this.addProductList) {
          for (let j of i.room) {
            this.roomList.push(j)
          }
        }
        this.roomList = this.$config.arrUnique(this.roomList, 'id')
        resolve()
      })
    },
    async init () {
      await this.setRoomList()
      if (this.roomList.length === 1) {
        this.roomCheck = this.roomList
        this.$store.commit('diag/setRoomCheck', this.roomList)
        this.step = 2
      } else {
        this.$refs.tableLayer.toggleAllSelection()
      }
    },
    next () {
      this.step = 2
    },
    close (task) {
      this.step = 1
      this.roomList = []
      this.title = this.$t('model.SelectRoom')
      this.$store.commit('diag/setAddProductList', [])
      this.btnLoading = false
      this.allFileList = []
      this.$emit('closeDialog', task)
    },
    closeGroupDialog (id) {
      if (id) {
        this.$store.dispatch('getTaskGroup').then(() => {
          this.$nextTick(() => {
            this.form.TaskPhaseId = id
          })
        })
      }
      this.groupDialog.showDialog = false
    },
    openGroupDialog () {
      this.groupDialog.showDialog = true
    },
    changeAssign () {
      this.form.AssignedUserIds = []
      if (this.assign.length < 1) {
        this.form.AssignedUserIds = []
      } else {
        this.form.AssignedUserIds.push(this.assign)
      }
    },
    getLocationShapeTypes () {
      // eslint-disable-next-line no-undef
      return [m2dw.ShapeType.ST_ROOM, m2dw.ShapeType.ST_ELEVATION, m2dw.ShapeType.ST_STAIRWAY, m2dw.ShapeType.ST_TOPELEVATION]
    },
    getTaskShapeId (prod) {
      let owner = prod.owner
      while (owner) {
        if (owner.id) {
          return owner.id
        }
        owner = owner.parentShape
      }
    },
    getRegionPerimeter (owner) {
      if (owner.region) {
        return owner.region.perimeter
      } else if (owner.parentShape.region) {
        return owner.parentShape.region.perimeter
      }
      return 0
    },
    save () {
      this.btnLoading = true
      let array = []
      if (!this.forAll) {
        let locationShapeTypes = this.getLocationShapeTypes()
        for (let ele of this.computedListForSave) {
          let obj = {}
          obj.AssignType = ele.product[0].owner.assignments[0].type
          obj.TaskId = uuid.v4()
          obj.RoomId = ele.room[0].id
          obj.JobsiteId = this.jobsiteID
          obj.PlanId = this.plan.PlanId
          obj.LayerShapeId = this.plan.LinkLayerShapeId
          obj.TaskType = 1
          obj.LocationType = ele.product[0].prod.LocationType
          obj.LocationShapeId = ele.room[0].id
          if (this.addProductList.length === 1) {
            obj.Name = this.Name
          } else {
            obj.Name = ele.product[0].prod.id + '-' + ele.room[0].name
          }
          obj.TaskProduct = {
            TaskId: obj.taskId,
            SKU: ele.product[0].prod.id,
            ProjectId: this.plan.LinkProjectId,
            Quantity: 0.0,
            TotalQty: 0
          }
          let arrShape = []
          let flag = false
          for (let i of ele.product) {
            let parent = i.owner.parentShape
            while (parent) {
              if (locationShapeTypes.includes(parent.type)) {
                if (!flag) {
                  var matchRoom = this.roomCheck.find(q => q.id === parent.id)
                  if (matchRoom) {
                    let point = this.$parent.$parent.getRandomPoint(matchRoom.id)
                    obj.LocationX = point.x
                    obj.LocationY = point.y
                    flag = true
                  } else {
                    flag = false
                  }
                }
                break
              }
              parent = parent.parentShape
            }
            if (flag === false || !parent) {
              continue
            }
            obj.TaskProduct.TotalQty += i.netArea
            obj.TaskProduct.Quantity += i.usage
            let TaskShapesObj = {}
            TaskShapesObj.ShapeId = this.getTaskShapeId(i)
            TaskShapesObj.ShapeName = parent.name
            TaskShapesObj.RoomShapeId = i.roomId
            TaskShapesObj.ShapeType = 0
            if (i.type === 1) {
              TaskShapesObj.ShapePerimeter = this.getRegionPerimeter(i.owner)
            }
            if (i.type === 2 || i.type === 3) {
              TaskShapesObj.ShapePerimeter = i.netArea
            }
            TaskShapesObj.ShapeArea = i.netArea
            arrShape.push(TaskShapesObj)
          }
          obj.TaskShapes = arrShape
          for (let i in this.form) {
            obj[i] = this.form[i]
          }
          array.push(obj)
        }
        let params = []
        params = array
        addTask(array).then(async res => {
          let taskIdList = []
          res.forEach(res => {
            if (!res.ParentTaskId) {
              taskIdList.push(res)
            }
          })
          if (taskIdList.length > 0) {
            if (params.length > 0) {
              await this.postUpPic(params[0].TaskId)
              this.btnLoading = false
              this.close(taskIdList)
            }
          } else {
            this.close()
          }
        }).catch(err => {
          this.btnLoading = false
          console.log(err)
        })
      } else {
        let list = []
        let array = []
        for (let i of this.roomCheck) {
          let obj = {
            room: i,
            point: i.position,
            product: i.assignment
          }
          list.push(obj)
        }
        for (let i of list) {
          let fatherTaskId = uuid.v4()
          let taskList = []
          for (let j of i.product) {
            if (j.prod && this.$config.IsTrackableProduct(j)) {
              if (!taskList.find(q => q.id === j.prod.id && q.assignType === j.TaskAssignType)) {
                taskList.push({ id: j.prod.id, assignType: j.TaskAssignType })
              }
            }
          }
          let obj = {}
          obj.JobsiteId = this.jobsiteID
          obj.RoomId = i.room.id
          obj.PlanId = this.plan.PlanId
          obj.LocationType = 1
          obj.LayerShapeId = this.plan.LinkLayerShapeId
          obj.Name = i.room.name
          obj.TaskId = fatherTaskId
          obj.TaskType = 4
          obj.IgnoreAddConflict = true
          obj.LocationX = i.point.x
          obj.LocationY = i.point.y
          obj.LocationShapeId = i.room.id
          let arrShape = []
          for (let a of i.room.floor.planRegions) {
            let TaskShapes = {
              ShapeId: a.id,
              ShapeName: i.room.name,
              ShapePerimeter: i.room.floor.region.perimeter,
              ShapeArea: i.room.floor.region.signedArea,
              RoomShapeId: i.room.id,
              ShapeType: 0
            }
            arrShape.push(TaskShapes)
          }
          obj.TaskShapes = arrShape
          for (let i in this.form) {
            obj[i] = this.form[i]
          }
          array.push(obj)
          taskList.forEach(item => {
            let obj = {}
            const id = uuid.v4()
            obj.TaskId = id
            let TaskProductObj = {
              SKU: item.id,
              ProjectId: this.plan.LinkProjectId,
              Quantity: 0.0,
              TotalQty: 0,
              TaskId: id
            }
            let arrShape = []
            i.product.forEach(res => {
              let TaskShapesObj = {}
              if (res.prod &&
                res.prod.id === item.id &&
                res.TaskAssignType === item.assignType) {
                TaskProductObj.Quantity += res.usage
                TaskProductObj.TotalQty += res.netArea
                if (res.locationType) {
                  obj.LocationType = res.locationType
                }
                obj.ProductType = res.type
                TaskShapesObj.ShapeId = this.getTaskShapeId(res)
                TaskShapesObj.ShapeName = i.room.name
                TaskShapesObj.RoomShapeId = i.room.id
                TaskShapesObj.ShapeType = 0
                if (res.type === 1) {
                  TaskShapesObj.ShapePerimeter = this.getRegionPerimeter(res.owner)
                }
                if (res.type === 2 || res.type === 3) {
                  TaskShapesObj.ShapePerimeter = res.netArea
                }
                TaskShapesObj.ShapeArea = res.netArea
                arrShape.push(TaskShapesObj)
              }
            })
            obj.TaskShapes = arrShape
            obj.AssignType = item.assignType
            obj.TaskProduct = TaskProductObj
            obj.JobsiteId = this.jobsiteID
            obj.RoomId = i.room.id
            obj.PlanId = this.plan.PlanId
            obj.LayerShapeId = this.plan.LinkLayerShapeId
            obj.Name = item.id
            obj.LocationX = 0.0
            obj.TaskType = 3
            obj.LocationY = 0.0
            obj.ParentTaskId = fatherTaskId
            for (let i in this.form) {
              obj[i] = this.form[i]
            }
            array.push(obj)
          })
        }
        let params = []
        params = array
        addTask(params).then(async res => {
          let taskIdList = []
          res.forEach(res => {
            if (!res.ParentTaskId) {
              taskIdList.push(res)
            }
          })
          if (taskIdList.length > 0) {
            if (params.length > 0) {
              await this.postUpPic(params[0].TaskId)
              this.btnLoading = false
              this.close(taskIdList)
            }
          } else {
            this.close()
          }
        }).catch(err => {
          this.btnLoading = false
          console.log(err)
        })
      }
    }
  },
  components: {
    GroupDialog
  }
}
</script>

<style lang="scss">
.form-box {
  .el-upload {
    width: 100%;
  }
}
</style>
<style lang="scss">
.form-box {
  .el-upload {
    width: 100%;
  }
}
</style>
<style scoped lang="scss">
.room-box {
  height: 400px;
}
.form-box {
  .el-upload {
    width: 100%;
  }
  width: 100%;
  overflow: hidden;
  .pic-box {
    height: 200px;
    overflow: hidden;
    width: 100%;
  }
}
.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
